import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  Text,
  Textarea,
} from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { visibleLength } from "./text/visibleLength";

export const ReasonModal = ({
  title,
  description,
  placeholder,
  confirmLabel,
  confirmColorScheme,
  reason,
  onReasonChange,
  isLoading,
  onConfirm,
  onClose,
  children,
  isConfirmDisabled = false,
  maxLength,
}: {
  title: string;
  description: string;
  placeholder?: string;
  confirmLabel: string;
  confirmColorScheme: string;
  reason: string;
  onReasonChange: (value: string) => void;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
  isConfirmDisabled?: boolean;
  maxLength?: number;
}) => {
  const { t } = useTranslation();
  const length = reason.trim().length;
  const tooLong = maxLength !== undefined && length > maxLength;
  return (
    <Modal isOpen onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="sm" color="smMuted" mb="3">
            {description}
          </Text>
          <FormControl isInvalid={tooLong}>
            <Textarea
              value={reason}
              onChange={(e) => onReasonChange(e.target.value)}
              placeholder={placeholder}
              rows={4}
              autoFocus
            />
            {maxLength !== undefined && (
              <FormHelperText>{t("{{count}} / {{max}} characters", { count: length, max: maxLength })}</FormHelperText>
            )}
            {maxLength !== undefined && (
              <FormErrorMessage>{t("The reason can be at most {{max}} characters.", { max: maxLength })}</FormErrorMessage>
            )}
          </FormControl>
          {children}
        </ModalBody>
        <ModalFooter
          gap="2"
          justifyContent="flex-start"
          flexDirection="row-reverse"
        >
          <Button
            colorScheme={confirmColorScheme}
            isDisabled={visibleLength(reason) === 0 || tooLong || isConfirmDisabled}
            isLoading={isLoading}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
          <Button variant="ghost" onClick={onClose}>
            {t("Cancel")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
